module.exports = __webpack_public_path__ + "img/undraw_Post_re_mtr4.b8a0755c.svg";